import BrowserRouter from '@fuse/core/BrowserRouter';
import FuseAuthorization from '@fuse/core/FuseAuthorization';
import FuseLayout from '@fuse/core/FuseLayout';
import FuseTheme from '@fuse/core/FuseTheme';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import withAppProviders from './withAppProviders';
import Notification from './shared-components/Notification';
import SnackbarProvider from './shared-components/SnackbarProvider';
import { ConfirmProvider } from './shared-components/modals';
import queryClient from './queryClient';
// import LiveChat from './LiveChat';
import Intercom from './Intercom';
import Auth from './auth';
import './initDateTime';

const App = () => {
  return (
    <Auth>
      <BrowserRouter>
        <FuseAuthorization>
          <FuseTheme>
            <SnackbarProvider>
              <ConfirmProvider>
                <QueryClientProvider client={queryClient}>
                  <FuseLayout />
                  <Notification />
                  <Intercom />
                  <ReactQueryDevtools />
                </QueryClientProvider>
              </ConfirmProvider>
              {/* {config.deploymentRegion === 'canada' && config.env !== 'local' && <LiveChat />} */}
            </SnackbarProvider>
          </FuseTheme>
        </FuseAuthorization>
      </BrowserRouter>
    </Auth>
  );
};

export default withAppProviders(App)();
